import { ArrowCounterClockwise } from '@phosphor-icons/react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useContactActions } from 'contacts/hooks';
import { IContact } from 'contacts/types';
import { Button } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

interface IProps {
  onSubmitSuccess?: () => void;
}

export const RestoreContactButton = ({ onSubmitSuccess }: IProps) => {
  const { t } = useTranslation();

  const { selectedRows, deselectAllRows } = useAgGridTableContext();
  const { restoreContacts, isRestoreContactsLoading } = useContactActions();

  const onRestoreContacts = useCallback(async () => {
    const contactIds = selectedRows.map((contact: IContact) => contact.id);

    const { success } = await restoreContacts(contactIds);

    if (success) {
      deselectAllRows();
      onSubmitSuccess?.();
    }
  }, [selectedRows, restoreContacts, deselectAllRows, onSubmitSuccess]);

  const isDisabled = useMemo(
    () => selectedRows.length === 0 || selectedRows.some((row: IContact) => !row.deleted),
    [selectedRows]
  );

  return (
    <Button
      text={t('buttonLabelRestore')}
      color={Color.SUCCESS}
      variant={isDisabled ? Variant.OUTLINED : Variant.SOFT}
      startDecorator={<ArrowCounterClockwise weight="bold" />}
      onClick={onRestoreContacts}
      disabled={isDisabled || isRestoreContactsLoading}
    />
  );
};
